import { render, staticRenderFns } from "./PendingProfit.vue?vue&type=template&id=466f8208"
import script from "./PendingProfit.vue?vue&type=script&lang=js"
export * from "./PendingProfit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports